import { apiClient as api } from "./httpClient";

// Salas da entidade e alocação de profissionais (sala padrão).
// A sala do atendimento é a sala padrão do profissional na data — remanejamentos pontuais
// não são registrados enquanto a agenda estiver no Bubble.

export interface RoomSpecialty {
  professionalTypeId: string;
  professionalTypeName: string;
}

export interface RoomAssignment {
  id: string;
  roomId: string;
  roomName: string;
  ueprId: string;
  professionalName: string;
  validFrom: string;
  validTo: string | null;
  /** alocação vigente hoje */
  current: boolean;
}

export interface Room {
  id: string;
  name: string;
  capacity: number | null;
  /** dias da semana (0=domingo … 6=sábado) em que a sala está alugada a terceiro — nesses dias sai do pool de capacidade */
  rentalWeekdays: number[];
  notes: string | null;
  active: boolean;
  specialties: RoomSpecialty[];
  assignments: RoomAssignment[];
}

export interface RoomProfessional {
  ueprId: string;
  professionalName: string;
  currentRoomId: string | null;
  currentRoomName: string | null;
}

export interface RoomPayload {
  name: string;
  capacity: number | null;
  rentalWeekdays: number[];
  notes: string | null;
  specialtyIds: string[];
}

export interface CreateRoomPayload extends RoomPayload {
  entityId: string;
}

export interface CreateAssignmentPayload {
  entityId: string;
  ueprId: string;
  roomId: string;
  /** início da vigência (YYYY-MM-DD); a alocação anterior é encerrada na véspera */
  validFrom: string;
}

export interface CreatedId {
  id: string;
}

export const roomsService = {
  getByEntity: async (entityId: string, includeInactive = false): Promise<Room[]> => {
    const response = await api.get(`/rooms/by-entity/${entityId}`, {
      params: { includeInactive },
    });
    return Array.isArray(response.data) ? response.data : [];
  },

  getProfessionals: async (entityId: string): Promise<RoomProfessional[]> => {
    const response = await api.get(`/rooms/professionals/${entityId}`);
    return Array.isArray(response.data) ? response.data : [];
  },

  create: async (payload: CreateRoomPayload): Promise<CreatedId> => {
    const response = await api.post("/rooms", payload);
    return response.data;
  },

  update: async (roomId: string, payload: RoomPayload): Promise<void> => {
    await api.put(`/rooms/${roomId}`, payload);
  },

  setActive: async (roomId: string, active: boolean): Promise<void> => {
    await api.patch(`/rooms/${roomId}/active`, { active });
  },

  createAssignment: async (payload: CreateAssignmentPayload): Promise<CreatedId> => {
    const response = await api.post("/rooms/assignments", payload);
    return response.data;
  },

  closeAssignment: async (assignmentId: string, endDate: string): Promise<void> => {
    await api.patch(`/rooms/assignments/${assignmentId}/close`, { endDate });
  },
};
